// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CL35","fullView":"styles_fullView__hGXJl"};